import React from "react";


import { useState } from "react";

function Settings({
  profile,
  setProfile,
  profileLoading,
  profileMessage,
  error,
  saveProfile,
  onBack,
  user
}) {
  const [localError, setLocalError] = useState({});
  const [email] = useState(profile.email || (user && user.email) || "");

  // Validation helpers
  const validate = () => {
    const errs = {};
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      errs.email = "Valid email is required.";
    }
    if (!profile.username || profile.username.trim().length < 3) {
      errs.username = "Username must be at least 3 characters.";
    }
    if (!profile.school || profile.school.trim().length < 2) {
      errs.school = "School is required.";
    } else if (/^\d+$/.test(profile.school.trim())) {
      errs.school = "School cannot be all numbers.";
    }
    if (!profile.major || profile.major.trim().length < 2) {
      errs.major = "Major is required.";
    } else if (/^\d+$/.test(profile.major.trim())) {
      errs.major = "Major cannot be all numbers.";
    }
    if (!profile.gradYear || !/^\d{4}$/.test(profile.gradYear)) {
      errs.gradYear = "Graduation Year must be 4-digits.";
    }
    return errs;
  };

  const handleSave = () => {
    const errs = validate();
    setLocalError(errs);
    if (Object.keys(errs).length > 0) return;
    // Save email to profile for update
    setProfile({ ...profile, email });
    saveProfile();
    onBack();
  };

  return (
    <div className="page-content">
      <div className="profile-content">
        {/* Avatar */}
        <div className="profile-avatar">
          <span>{profile.username ? profile.username[0].toUpperCase() : ''}</span>
        </div>

        <h2 className="profile-section-title">Update Profile</h2>

        {profileLoading ? (
          <p>Loading profile...</p>
        ) : (
          <>
            <div className="form-group">
              <label>
                Email <span className="required">*</span>
              </label>
              <input
                className="profile-input"
                type="email"
                value={email}
                readOnly
                style={{ backgroundColor: '#f5f5f5', color: '#888', cursor: 'not-allowed' }}
              />
              {localError.email && <p className="error-message">{localError.email}</p>}
            </div>

            <div className="form-group">
              <label>
                Username <span className="required">*</span>
              </label>
              <input
                className={`profile-input ${localError.username ? 'error' : ''}`}
                type="text"
                value={profile.username || ""}
                onChange={(e) =>
                  setProfile({ ...profile, username: e.target.value })
                }
              />
              {localError.username && <p className="error-message">{localError.username}</p>}
            </div>

            <div className="form-group">
              <label>
                School <span className="required">*</span>
              </label>
              <input
                className={`profile-input ${localError.school ? 'error' : ''}`}
                type="text"
                value={profile.school || ""}
                onChange={(e) =>
                  setProfile({ ...profile, school: e.target.value })
                }
              />
              {localError.school && <p className="error-message">{localError.school}</p>}
            </div>

            <div className="form-group">
              <label>
                Major <span className="required">*</span>
              </label>
              <input
                className={`profile-input ${localError.major ? 'error' : ''}`}
                type="text"
                value={profile.major || ""}
                onChange={(e) =>
                  setProfile({ ...profile, major: e.target.value })
                }
              />
              {localError.major && <p className="error-message">{localError.major}</p>}
            </div>

            <div className="form-group">
              <label>
                Graduation Year <span className="required">*</span>
              </label>
              <input
                className={`profile-input ${localError.gradYear ? 'error' : ''}`}
                type="text"
                placeholder="2026"
                value={profile.gradYear || ""}
                onChange={(e) =>
                  setProfile({ ...profile, gradYear: e.target.value })
                }
              />
              {localError.gradYear && <p className="error-message">{localError.gradYear}</p>}
            </div>

            <div className="profile-buttons">
              <button onClick={handleSave}>[save]</button>
              <button onClick={onBack}>[cancel]</button>
            </div>

            {profileMessage && (
              <p className="success-message">{profileMessage}</p>
            )}
            {error && <p className="error-message">{error}</p>}
          </>
        )}
      </div>
    </div>
  );
}

export default Settings;